/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import dayjs from "dayjs";

/**
 * Formats a date string to the specified format
 * @param dateString - The date string to format (can be null or undefined)
 * @param format - The format string to use (defaults to 'DD/MM/YYYY')
 * @returns Formatted date string, 'Not specified' if dateString is null/undefined, or 'Invalid date' if date is invalid
 */
export const formatDate = (
  dateString: string | null | undefined,
  format = "DD/MM/YYYY"
): string => {
  if (!dateString) {
    return "Not specified";
  }
  const date = dayjs(dateString);
  return date.isValid() ? date.format(format) : "Invalid date";
};
